import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  IconButton
} from '@mui/material';
import {
  People as PeopleIcon,
  Campaign as AnnouncementIcon,
  Event as EventIcon,
  Photo as PhotoIcon,
  Message as MessageIcon,
  ArrowForward as ArrowIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

const StatItem = ({ icon: Icon, label, value, color, to }) => {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 2,
        borderRadius: 2,
        bgcolor: 'background.default',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 2
        }
      }}
    >
      <Icon sx={{ fontSize: 32, color: color || 'primary.main', mb: 1 }} />
      <Typography variant="h5" sx={{ fontWeight: 600 }}>
        {value || 0}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );

  if (!to) {
    return content;
  }

  return (
    <Box
      component={Link}
      to={to}
      sx={{
        textDecoration: 'none',
        color: 'inherit',
        display: 'block'
      }}
    >
      {content}
    </Box>
  );
};

const QuickStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Family Activity
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Loading stats...
          </Typography>
        </CardContent>
      </Card>
    );
  }

  const statLinks = {
    Members: '/contacts',
    Announcements: '/announcements',
    Events: '/events',
    Photos: '/photos?tab=family',
    Posts: '/family-board?tab=feed'
  };

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography
            variant="h6"
            component={Link}
            to="/family-board"
            sx={{
              textDecoration: 'none',
              color: 'inherit',
              cursor: 'pointer',
              '&:hover': {
                color: 'primary.main'
              }
            }}
          >
            Family Activity
          </Typography>
          <IconButton
            component={Link}
            to="/family-board"
            size="small"
            title="View all family activity"
          >
            <ArrowIcon />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatItem
              icon={PeopleIcon}
              label="Members"
              value={stats?.totalMembers}
              color="primary.main"
              to={statLinks.Members}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatItem
              icon={AnnouncementIcon}
              label="Announcements"
              value={stats?.totalAnnouncements}
              color="info.main"
              to={statLinks.Announcements}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatItem
              icon={EventIcon}
              label="Events"
              value={stats?.totalEvents}
              color="secondary.main"
              to={statLinks.Events}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatItem
              icon={PhotoIcon}
              label="Photos"
              value={stats?.totalPhotos}
              color="success.main"
              to={statLinks.Photos}
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <StatItem
              icon={MessageIcon}
              label="Posts"
              value={stats?.totalPosts}
              color="warning.main"
              to={statLinks.Posts}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickStats;
